import { atomWithStorage } from 'jotai/utils';

import { GlobalStateKeyEnum } from '@lib/enums';

export type TCurrentCallAtom = Readonly<{
  lastRoutedContactId: Nullable<string>;
  lastRoutedContactMasterId: Nullable<string>;
  lastAcwContactId: Nullable<string>;
  lastTouchedQuoteId: Nullable<string>;
  lastTouchedQuoteContactId: Nullable<string>;
  lastTouchedQuoteContactMasterId: Nullable<string>;
  lastTouchedConsumerId: Nullable<number>;
  isNoteForRetentionEntered: Nullable<boolean>;
}>;

export const INITIAL_CURRENT_CALL_STATE = {
  lastRoutedContactId: null,
  lastRoutedContactMasterId: null,
  lastAcwContactId: null,
  lastTouchedQuoteId: null,
  lastTouchedQuoteContactId: null,
  lastTouchedQuoteContactMasterId: null,
  lastTouchedConsumerId: null,
  isNoteForRetentionEntered: false,
} satisfies TCurrentCallAtom;

const currentCallAtom = atomWithStorage<TCurrentCallAtom>(
  GlobalStateKeyEnum.CurrentCall,
  INITIAL_CURRENT_CALL_STATE,
);

export { currentCallAtom };
